import { useEffect, useState } from 'react';

/**
 * Mise à jour de l'application installée.
 *
 * <p>Le service worker est enregistré avant que React ne se monte : ce module
 * garde la version en attente et prévient les écrans qui l'écoutent.
 */

let enAttente = null;
const abonnes = new Set();

/**
 * Signale qu'une nouvelle version est installée et attend d'être activée.
 *
 * @param {ServiceWorker} worker la version en attente
 */
export function signaleNouvelleVersion(worker) {
  enAttente = worker;
  abonnes.forEach((f) => f(worker));
}

/**
 * Demande à la version en attente de prendre la main. La page se recharge
 * ensuite d'elle-même (`controllerchange`).
 *
 * @param {ServiceWorker} worker la version en attente
 */
export function activeNouvelleVersion(worker) {
  if (worker && typeof worker.postMessage === 'function') {
    worker.postMessage({ type: 'SKIP_WAITING' });
  }
}

/**
 * La version en attente, ou `null`.
 *
 * @returns {ServiceWorker|null} la version en attente
 */
export function useNouvelleVersion() {
  const [worker, setWorker] = useState(enAttente);
  useEffect(() => {
    abonnes.add(setWorker);
    if (enAttente) setWorker(enAttente);
    return () => abonnes.delete(setWorker);
  }, []);
  return worker;
}

/** Réservé aux tests : oublie la version en attente. */
export function _oublieNouvelleVersion() {
  enAttente = null;
}
